import { ThemeEvents } from '@theme/events';
window.theme = window.theme || {};
theme.utils = {
    debounce: function(wait, callback, immediate) {
        var timeout;
        return function() {
          var context = this, args = arguments;
          var later = function() {
            timeout = null;
            if (!immediate) callback.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) callback.apply(context, args);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Mega menu hover
    const megaMenuHoverLinks = document.querySelectorAll('.js-menu-hover-link');
    if(megaMenuHoverLinks.length > 0) {
        megaMenuHoverLinks.forEach(link => {
            link.addEventListener('mouseover', function(e) {
                const parent = e.target.closest('.custom-mega-menu__grid');
                const targetID = e.target.getAttribute('data-target');
                const childMegaMenuHoverLinks = parent.querySelectorAll('.js-menu-hover-link');
                const megaMenuHoverContents = parent.querySelectorAll('.mega-menu-left-contents');
                childMegaMenuHoverLinks.forEach(link => {
                    link.classList.remove('active');
                });
                e.target.classList.add('active');
                megaMenuHoverContents.forEach(el => {
                    el.classList.remove('active');
                });
                const targetContainer = parent.querySelector(`.mega-menu-left-contents[data-hover=${targetID}]`);
                targetContainer.classList.add('active');
            });
        })
    }
    const productImageHover = document.querySelectorAll('.contains-mega-menu-image [data-image-target]');
    if(productImageHover.length > 0) {
        productImageHover.forEach(link => {
            const parent = link.closest('.contains-mega-menu-image');
            const defaultImg = parent.querySelector('.custom-mega-menu-image-wrap img[data-image="default"]');
            let imgToShow;
            link.addEventListener('mouseover', theme.utils.debounce(200, function(e) {   
                const imgTarget = e.target.getAttribute('data-image-target');
                imgToShow = parent.querySelector(`img[data-image=${imgTarget}]`);
                const currentImgSrc = imgToShow.getAttribute('src');
                const imgSrc = imgToShow.getAttribute('data-src-url');
                if(currentImgSrc === '') {
                    imgToShow.setAttribute('src', imgSrc);
                }
                defaultImg.classList.remove('active');
                imgToShow.classList.add('active');
            }));

            link.addEventListener('mouseleave', theme.utils.debounce(200, function() {
                imgToShow.classList.remove('active');
                defaultImg.classList.add('active');
            }));
        });
    }

    // Custom mobile menu
    const menuBtns = document.querySelectorAll('.js-open-next-menu');
    if(menuBtns.length > 0) {
        menuBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.target.closest('.mobile-slide-menu-parent')?.classList.remove('active');
                e.target.closest('.mobile-nav__has-sublist')?.querySelector('.mobile-slide-menu-parent')?.classList.add('active');
            });
        });
    }
    const menuBackBtns = document.querySelectorAll('.js-back-to-prev-menu');
    if(menuBackBtns.length > 0) {
        menuBackBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                const parent = e.target.closest('.mobile-slide-menu-parent');
                if(parent) {
                    parent.closest('.mobile-slide-menu-parent:not(.active)')?.classList.add('active');
                    parent.classList.remove('active');
                }
            });
        })
    }

    // KK Footer Links - from previous theme (modified to use menu link and vanilla JS)
    // Hide the "Hide Popular Links" when the page loads
    const showPopularSearchesBtn = document.querySelector('.menu__item a[href="#popular-searches"]');
    const popularSearchesContainer = document.getElementById('popular-searches');
    if(showPopularSearchesBtn && popularSearchesContainer) {
        showPopularSearchesBtn.addEventListener('click', function(e) {
            popularSearchesContainer.style.display = 'block';
        });
    }

    // Featured product card: wrap all items except gallery in a div so grid has 2 children (gallery + wrapper)
    wrapFeaturedProductCardColumn();
});

document.addEventListener(ThemeEvents.FilterUpdate, (e) => { wrapFeaturedProductCardColumn(); });
document.addEventListener('collection-grid-updated', (e) => { wrapFeaturedProductCardColumn(); });

function wrapFeaturedProductCardColumn() {
    document.querySelectorAll('.product-grid__item--featured .product-card__content').forEach(function(content) {
        if (content.querySelector(':scope > .featured-product-card__content-column')) return; // already wrapped
        var gallery = content.querySelector(':scope > .card-gallery');
        if (!gallery) return;
        var toWrap = [];
        for (var i = 0; i < content.children.length; i++) {
            var el = content.children[i];
            if (el !== gallery && !el.classList.contains('product-grid-view-zoom-out--details')) toWrap.push(el);
        }
        if (toWrap.length === 0) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'featured-product-card__content-column';
        gallery.after(wrapper);
        toWrap.forEach(function(el) { wrapper.appendChild(el); });
    });
}
if (typeof window.theme !== 'undefined') window.theme.wrapFeaturedProductCardColumn = wrapFeaturedProductCardColumn;

/*  ===================================
 *  FREE SHIPPING TRESHOLD WIDGET
 *  - Simple widget that adds a progress bar indicating how far they are for free shipping
 *  ===================================
 */

(function(w,d){
    const settings = {
        container: 'FSTContainer',
        progress_bar: 'FSTBar',
        message: 'FSTMessage',
        message_error: 'Please enter a target goal amount in the Theme Settings > Cart > Free Shipping Threshold'
    }
    let container = null;
    let data;
    let exchange_rate = Shopify.currency.rate;

    let initStarted = false;
    let observer = null;

    function initData() {
        const dataset = container.dataset.settings ?? new Object;
        if (Object.keys(dataset).length === 0) return;
        data = JSON.parse(dataset);
    }

    function fetchCartData() {
        fetch((window.theme.routes.cart ? window.theme.routes.cart : '/cart.js'), {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => calculateShipping(data));
    }

    function renderElements() {
        // Set data
        let currency_modifier = 1;
        let symbol = "$"
        let convert = false;
        if (data.shop_currency != data.cart_currency) {
            currency_modifier = exchange_rate;
            symbol = `${window.theme.settings.cartCurrencySymbol}`;
            convert = true;
        }
        const mod_target = data.target ? parseFloat(data.target) * currency_modifier : null;
        const mod_step_target = data.step_target ? parseFloat(data.step_target) * currency_modifier : null;
        
        const labelHTML = d.createElement('label')
        labelHTML.setAttribute('for', settings.progress_bar)
        // labelHTML.textContent = 'Free shipping progress'

        const progressBarHTML = d.createElement('progress')
        progressBarHTML.id = settings.progress_bar
        progressBarHTML.setAttribute('max', 100)
        progressBarHTML.setAttribute('value', 0)
        progressBarHTML.dataset.target = data.target ?? null

        const progressBarWrapper = d.createElement('div')
        progressBarWrapper.classList.add('fst-progress-bar-wrapper')
        progressBarWrapper.dataset.symbol = symbol
        if (convert) {
            if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                progressBarWrapper.dataset.target = mod_target.toFixed(0) ?? null
            } else {
                progressBarWrapper.dataset.target = mod_target.toFixed(2) ?? null
            }
        } else {
            progressBarWrapper.dataset.target = data.target ?? null
        }
        progressBarWrapper.appendChild(progressBarHTML)

        const messageHTML = d.createElement('div')
        messageHTML.id = settings.message
        messageHTML.classList.add('fst-message')

        container.appendChild(messageHTML);
        container.appendChild(labelHTML);
        
        // Step Label
        if (data.step_target && data.step_target != '') {
            const stepLabel = d.createElement('span');
            stepLabel.classList.add("fst-step-target");
            stepLabel.setAttribute('data-pos', `${(parseInt(data.step_target) / parseInt(data.target)) * 100}`);
            stepLabel.style.left = `${(parseInt(data.step_target) / parseInt(data.target)) * 100}%`;
            if (convert) {
                if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                    stepLabel.innerHTML = `${symbol}${mod_step_target.toFixed(0)}`;
                } else {
                    stepLabel.innerHTML = `${symbol}${mod_step_target.toFixed(2)}`;
                }
            } else {
                stepLabel.innerHTML = `$${data.step_target}`;
            }

            progressBarWrapper.appendChild(stepLabel);
        }
        
        container.appendChild(progressBarWrapper);
    }

    function calculateShipping(cartJson) {
        let currency_modifier = 1;
        let symbol = "$"
        let convert = false;
        if (data.shop_currency != data.cart_currency) {
            currency_modifier = exchange_rate;
            symbol = `${window.theme.settings.cartCurrencySymbol}`;
            convert = true;
            // cart_total = cart_total / exchange_rate;
        }

        const target = data.target ? parseFloat(data.target) : null;
        const mod_target = data.target ? parseFloat(data.target) * currency_modifier : null;
        let cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price) / 100;
        let mod_cart_total = cart_total / currency_modifier;

        let progress_value = (cart_total / target) * 100;
        progress_value = (mod_cart_total / target) * 100;

        const remaining = target - cart_total;
        const mod_remaining = mod_target - cart_total;
        let message = '';

        if (target) {
            // Set value of progress bar
            const pbar_elem = d.getElementById(settings.progress_bar);
            if (pbar_elem) {
                if (progress_value >= 100){
                    pbar_elem.setAttribute('value', 100);
                    pbar_elem.parentElement.setAttribute('value', 100);
                    pbar_elem.style.setProperty('--percentage', "calc(100% - 14px)");
                }
                else {
                    pbar_elem.setAttribute('value', progress_value ? progress_value : 0);
                    pbar_elem.parentElement.setAttribute('value', progress_value ? progress_value : 0);
                    pbar_elem.style.setProperty('--percentage', `calc(${progress_value ? progress_value : 0}% - 14px)`);
                }
            }
            

            const stepTarget = data.step_target ? parseFloat(data.step_target) : null;
            const mod_step_target = data.step_target ? parseFloat(data.step_target) * currency_modifier : null;
            const stepMessage = data.message_step_ongoing;

            // message = data.message_default.replace('[target]', `$${target}`);
            if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                message = data.message_default.replace('[target]', `${symbol}${mod_target.toFixed(0)}`);
            } else {
                message = data.message_default.replace('[target]', `${symbol}${mod_target.toFixed(2)}`);
            }
            if (mod_remaining <= 0) {
                message = data.message_success;
            }
            if (mod_remaining > 0 && mod_remaining < mod_target) {
                // message = data.message_ongoing.replace('[remaining]', `$${remaining ? remaining.toFixed(2) : target}`);
                if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                    message = data.message_ongoing.replace('[remaining]', `${symbol}${remaining ? mod_remaining.toFixed(0) : mod_target}`);
                } else {
                    message = data.message_ongoing.replace('[remaining]', `${symbol}${remaining ? mod_remaining.toFixed(2) : mod_target}`);
                }
            }

            if (stepTarget) {
                const mod_step_target = stepTarget * currency_modifier;
                const stepRemaining = stepTarget - cart_total;
                const mod_step_remaining = mod_step_target - cart_total;

                if (mod_step_remaining > 0) {
                    // message = stepMessage.replace('[remaining]', `$${stepRemaining ? stepRemaining.toFixed(2) : stepTarget}`);
                    if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                        message = stepMessage.replace('[remaining]', `${symbol}${stepRemaining ? mod_step_remaining.toFixed(0) : mod_step_target}`);
                    } else {
                        message = stepMessage.replace('[remaining]', `${symbol}${stepRemaining ? mod_step_remaining.toFixed(2) : mod_step_target}`);
                    }
                }
            }
        }
        else
            message = settings.message_error

        // Display message
        d.getElementById(settings.message).innerHTML = message;

        // Hide free shipping widget when cart has a product type of "Rods" or "Rods - Seacore"
        let rodsChecker = cartJson.items.find(x => x.product_type === 'Rods' || x.product_type === 'Rods - Seacore' );

        if ( rodsChecker ) {
            document.querySelector('#CartDrawer .cart-drawer__header').classList.add('has-rods');
        } else {
            document.querySelector('#CartDrawer .cart-drawer__header').classList.remove('has-rods');
        }
    }

    function init() {
        if (initStarted) return;
        
        container = d.getElementById(settings.container);

        if (!container) {
            watchForContainer();
            return;
        }

        initStarted = true;

        initData();
        renderElements();
        fetchCartData();

        // Listeners for product added and cart updates
        ['cart:update', 'ajaxProduct:added'].forEach(evt =>
            d.addEventListener(evt, fetchCartData, false)
        );

        if (observer) observer.disconnect();
    }

    function watchForContainer() {
        if (observer) return;

        observer = new MutationObserver(() => {
            const found = document.getElementById(settings.container);
            if (found) {
                container = found;
                init();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    init();
})(window, document)

class VariantSelect extends HTMLElement {
    constructor() {
        super();
        this.location = this.getAttribute('data-location');
        this.selectedVariantImageId = null;
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handlePointerOver = this.handlePointerOver.bind(this);
        this.handlePointerOut = this.handlePointerOut.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleSwatchesMouseLeave = this.handleSwatchesMouseLeave.bind(this);
    }

    connectedCallback() {
        this.addEventListener('change', this.handleChange);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('pointerover', this.handlePointerOver);
        this.addEventListener('pointerout', this.handlePointerOut);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        this.swatchesContainer = this.querySelector('.product-card-variant-select__swatches');
        this.swatchesContainer?.addEventListener('mouseleave', this.handleSwatchesMouseLeave);
        this.syncSelectedState();
        this.selectedVariantImageId = this.getSelectedVariantImageId();
        requestAnimationFrame(() => this.scrollSelectedSwatchIntoView(null, 'auto'));
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('pointerover', this.handlePointerOver);
        this.removeEventListener('pointerout', this.handlePointerOut);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.swatchesContainer?.removeEventListener('mouseleave', this.handleSwatchesMouseLeave);
    }

    handleChange(event) {
        const source = event.target;
        if (!(source instanceof HTMLInputElement || source instanceof HTMLSelectElement)) return;

        const selectedOptionElement = source instanceof HTMLSelectElement ? source.selectedOptions[0] : source;
        if (!selectedOptionElement) return;

        const selectedOption = selectedOptionElement.value;
        this.syncSelectedState(selectedOptionElement);
        let variantImageId = selectedOptionElement.getAttribute('data-variant-image');
        let variantImageUrl = null;
        this.selectedVariantImageId = variantImageId || this.getSelectedVariantImageId();
        if(this.location === 'cart-upsell') {
            variantImageId = null;
            variantImageUrl = selectedOptionElement.getAttribute('data-variant-image');
        }
        this.updateVariantImage(variantImageId, variantImageUrl);
        this.updateQuickAddButton(selectedOption);
        this.updatePrice(selectedOptionElement);
        this.updateProductLink(selectedOptionElement);
        this.dispatchEvent(
            new CustomEvent(ThemeEvents.variantSelected, {
                bubbles: true,
                detail: {
                    resource: {
                        id: selectedOption,
                    },
                },
            })
        );
        this.updateProductFormState(selectedOptionElement);
        this.scrollSelectedSwatchIntoView(selectedOptionElement);
    }

    handleClick(event) {
        const trigger = event.target instanceof Element
            ? event.target.closest('[data-carousel-previous], [data-carousel-next]')
            : null;

        if (!trigger) return;

        event.preventDefault();

        if (trigger.hasAttribute('data-carousel-previous')) {
            this.scrollCarousel(-1);
        } else if (trigger.hasAttribute('data-carousel-next')) {
            this.scrollCarousel(1);
        }
    }

    handlePointerOver(event) {
        if (event.pointerType !== 'mouse') return;

        const swatchLabel = event.target instanceof Element
            ? event.target.closest('.product-card-variant-select__swatch-label')
            : null;
        if (!(swatchLabel instanceof HTMLElement) || !this.contains(swatchLabel)) return;

        const relatedLabel = event.relatedTarget instanceof Element
            ? event.relatedTarget.closest('.product-card-variant-select__swatch-label')
            : null;
        if (relatedLabel === swatchLabel) return;

        const swatchInput = swatchLabel.querySelector('input[data-variant-image]');
        const variantImageId = swatchInput?.getAttribute('data-variant-image');
        if (!variantImageId) return;

        this.updateVariantImage(variantImageId, null);
    }

    handlePointerOut(event) {
        if (event.pointerType !== 'mouse') return;

        const swatchLabel = event.target instanceof Element
            ? event.target.closest('.product-card-variant-select__swatch-label')
            : null;
        if (!(swatchLabel instanceof HTMLElement) || !this.contains(swatchLabel)) return;

        const nextLabel = event.relatedTarget instanceof Element
            ? event.relatedTarget.closest('.product-card-variant-select__swatch-label')
            : null;
        if (nextLabel && this.contains(nextLabel)) return;

        this.resetHoveredVariantPreview();
    }

    handleMouseLeave() {
        this.resetHoveredVariantPreview();
    }

    handleSwatchesMouseLeave() {
        this.resetHoveredVariantPreview();
    }

    resetHoveredVariantPreview() {
        const selectedVariantImageId = this.selectedVariantImageId || this.getSelectedVariantImageId();
        if (selectedVariantImageId) {
            this.updateVariantImage(selectedVariantImageId, null);
        }
    }

    getSelectedVariantImageId() {
        const checkedInput = this.querySelector('input[type="radio"]:checked[data-variant-image]');
        if (checkedInput instanceof HTMLInputElement && checkedInput.dataset.variantImage) {
            return checkedInput.dataset.variantImage;
        }

        const selectedInput = this.querySelector('input[type="radio"][data-selected="true"][data-variant-image]');
        if (selectedInput instanceof HTMLInputElement && selectedInput.dataset.variantImage) {
            return selectedInput.dataset.variantImage;
        }

        const select = this.querySelector('select');
        const selectedOption = select?.selectedOptions?.[0];
        return selectedOption?.getAttribute('data-variant-image') || null;
    }

    syncSelectedState(selectedOptionElement = null) {
        const radioInputs = this.querySelectorAll('input[type="radio"][data-variant-id]');
        if (!radioInputs.length) return;

        const currentInput =
            selectedOptionElement instanceof HTMLInputElement
                ? selectedOptionElement
                : this.querySelector('input[type="radio"]:checked[data-variant-id]') ||
                  this.querySelector('input[type="radio"][data-selected="true"][data-variant-id]');

        radioInputs.forEach((input) => {
            input.dataset.selected = 'false';
        });

        if (currentInput instanceof HTMLInputElement) {
            currentInput.dataset.selected = 'true';
        }
    }

    scrollCarousel(direction) {
        const swatchesContainer = this.querySelector('.product-card-variant-select__swatches');
        if (!(swatchesContainer instanceof HTMLElement)) return;

        const items = Array.from(this.querySelectorAll('.product-card-variant-select__swatch-item'));
        if (items.length <= 1) return;

        const containerCenter = swatchesContainer.scrollLeft + swatchesContainer.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
            if (!(item instanceof HTMLElement)) return;

            const itemCenter = item.offsetLeft + item.offsetWidth / 2;
            const distance = Math.abs(itemCenter - containerCenter);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });

        const nextIndex = (closestIndex + direction + items.length) % items.length;
        const nextItem = items[nextIndex];
        if (!(nextItem instanceof HTMLElement)) return;

        const targetLeft = nextItem.offsetLeft - (swatchesContainer.clientWidth / 2) + (nextItem.offsetWidth / 2);
        const maxScrollLeft = swatchesContainer.scrollWidth - swatchesContainer.clientWidth;
        const clampedLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

        swatchesContainer.scrollTo({
            left: clampedLeft,
            behavior: 'smooth',
        });
    }

    scrollSelectedSwatchIntoView(selectedOptionElement = null, behavior = 'smooth') {
        const swatchesContainer = this.querySelector('.product-card-variant-select__swatches');
        if (!(swatchesContainer instanceof HTMLElement)) return;

        const currentInput =
            selectedOptionElement instanceof HTMLInputElement
                ? selectedOptionElement
                : this.querySelector('input[type="radio"]:checked[data-variant-id]') ||
                  this.querySelector('input[type="radio"][data-selected="true"][data-variant-id]');

        const currentItem = currentInput?.closest('.product-card-variant-select__swatch-item');
        if (!(currentItem instanceof HTMLElement)) return;

        const containerWidth = swatchesContainer.clientWidth;
        const itemWidth = currentItem.offsetWidth;
        const targetLeft = currentItem.offsetLeft - (containerWidth / 2) + (itemWidth / 2);
        const maxScrollLeft = swatchesContainer.scrollWidth - containerWidth;
        const clampedLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

        swatchesContainer.scrollTo({
            left: clampedLeft,
            behavior,
        });
    }

    updateVariantImage(variantImageId, variantImageUrl) {
        if (variantImageId) {
            const card = this.closest('product-card');
            if (card && typeof card.showVariantMedia === 'function') {
                card.showVariantMedia(variantImageId);
                return;
            }

            const slideshow = card?.querySelector('slideshow-component');
            if (!slideshow) return;
            const slides = slideshow.refs?.slides ?? slideshow.querySelectorAll('slideshow-slide[variant-image]');
            const mediaId = String(variantImageId);
            if (slides?.length) {
                for (const slide of slides) {
                    if (!slide.hasAttribute('variant-image')) continue;
                    const isSelected = slide.getAttribute('slide-id') === mediaId;
                    slide.hidden = !isSelected;
                    slide.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
                    if (!isSelected) slide.removeAttribute('reveal');
                }
            }
            if (typeof slideshow.select === 'function') {
                slideshow.select({ id: mediaId }, undefined, { animate: false });
            }
        } else if (variantImageUrl) {
            const upsell = this.closest('.product-card-upsell');
            const image = upsell?.querySelector('.product-card-upsell__image img');
            if (image) image.src = variantImageUrl;
        }
    }

    updateQuickAddButton(variantId) {
        let parent = this.closest('product-card');
        if(this.location === 'cart-upsell') {
            parent = this.closest('.product-card-upsell');
        } 
          
        if (!parent) return;
        const variantInputs = parent.querySelectorAll('product-form-component input[name="id"]');
        variantInputs.forEach((input) => {
            input.value = variantId;
        });
    }

    updatePrice(selectedOptionElement) {
        let parent = this.closest('product-card');
        if(this.location === 'cart-upsell') {
            parent = this.closest('.product-card-upsell');
        } 
        if (!parent) return;
        const priceContainer = parent.querySelector('[ref="priceContainer"] .price');
        if (!selectedOptionElement) return;

        const formattedPrice = selectedOptionElement.getAttribute('data-price-formatted');
        const priceMajor = selectedOptionElement.getAttribute('data-price-major');
        const priceMinor = selectedOptionElement.getAttribute('data-price-minor');
        const priceSeparator = selectedOptionElement.getAttribute('data-price-separator');

        if (formattedPrice && priceContainer) {
            if (priceMajor && priceMinor && priceSeparator) {
                priceContainer.replaceChildren();

                const dollarsSpan = document.createElement('span');
                dollarsSpan.className = 'price-dollars';
                dollarsSpan.textContent = priceMajor;

                const centsSpan = document.createElement('span');
                centsSpan.className = 'price-cents';
                centsSpan.textContent = `${priceSeparator}${priceMinor}`;

                priceContainer.append(dollarsSpan, centsSpan);
            } else {
                priceContainer.textContent = formattedPrice;
            }
        }
    }

    updateProductLink(selectedOptionElement) {
        const variantUrl = selectedOptionElement?.getAttribute('data-variant-url');
        if (!variantUrl) return;

        const parent = this.closest('product-card');
        if (!parent) return;

        const productLinks = parent.querySelectorAll('[ref="productCardLink"], [ref="productTitleLink"], [ref="cardGalleryLink"]');
        productLinks.forEach((link) => {
            if (link instanceof HTMLAnchorElement) {
                link.href = variantUrl;
            }
        });
    }

    updateProductFormState(selectedOptionElement) {
        let parent = this.closest('product-card');
        if(this.location === 'cart-upsell') {
            parent = this.closest('.product-card-upsell');
        }
        if (!parent) return;

        const availabilityAttribute = selectedOptionElement?.getAttribute('data-option-available');
        const isAvailable = availabilityAttribute === 'true'
            || (
                availabilityAttribute === null
                && selectedOptionElement instanceof HTMLOptionElement
                && selectedOptionElement.disabled === false
            );
        const variantMedia = selectedOptionElement?.getAttribute('data-product-variant-media');
        const productForms = parent.querySelectorAll('product-form-component');

        productForms.forEach((productForm) => {
            const variantInput = productForm.querySelector('input[name="id"]');
            if (variantInput instanceof HTMLInputElement) {
                if (isAvailable) {
                    variantInput.removeAttribute('disabled');
                } else {
                    variantInput.setAttribute('disabled', 'disabled');
                }
            }

            const addToCartComponents = productForm.querySelectorAll('add-to-cart-component');
            addToCartComponents.forEach((component) => {
                if (variantMedia) {
                    component.setAttribute('data-product-variant-media', variantMedia);
                }

                if (typeof component.enable === 'function' && typeof component.disable === 'function') {
                    if (isAvailable) {
                        component.enable();
                    } else {
                        component.disable();
                    }
                }
            });
        });
    }
}

if(!customElements.get('variant-select')) {
    customElements.define('variant-select', VariantSelect);
}

class CartCrossSell extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSlider();
    }

    initSlider() {
        const slider = tns({
            container: this.querySelector('.cross-sell-products'),
            items: 1,
            slideBy: 1,
            autoplay: false,
            loop: false,
            controls: true,
            navPosition: 'bottom',
            prevButton: this.querySelector('.cross-sell-products__prev'),
            nextButton: this.querySelector('.cross-sell-products__next'),
        });
    }
}

if(!customElements.get('cart-cross-sell')) {
    customElements.define('cart-cross-sell', CartCrossSell);
}

// PDP Specs Table
window.addEventListener('DOMContentLoaded', () => {
    const variantSpecTableElems = document.querySelectorAll('.specs-table__content--variant-table[data-variant-id]');
    const variantSpecAccordionElems = document.querySelectorAll('.specs-table__details--variant-accordion[data-variant-id]');

    if (variantSpecTableElems.length > 0 || variantSpecAccordionElems.length > 0) {
        document.addEventListener(ThemeEvents.variantUpdate, (e) => {
            const selectedVariantId = `${e.detail?.resource?.id || ''}`;

            if (!selectedVariantId) {
                return;
            }

            variantSpecTableElems.forEach((elem) => {
                elem.classList.add('hidden');
            });

            const selectedVariantTable = document.querySelector(`.specs-table__content--variant-table[data-variant-id="${selectedVariantId}"]`);
            if (selectedVariantTable) {
                selectedVariantTable.classList.remove('hidden');
            }

            variantSpecAccordionElems.forEach((elem) => {
                elem.open = elem.dataset.variantId === selectedVariantId;
            });
        });
    }
});
